/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientMerge {
  angular.module("meevo.plugins.clientMerge", []);
}